import classNames from 'classnames';
import { GridCol, GridContainer, GridRow } from '@medifind/containers';
import { useHeadingNavigationLinks } from '@medifind/hooks';
import { Skeleton } from '@medifind/shared-basic-components';
import BoxButtons from './BoxButtons';
import BoxNavigation from './BoxNavigation';
import styles from './HeadingBox.module.scss';

const HeadingBox = ({ links = [], topRowChildren, sideChildren, noMarginTopRow, smallAt, classes = {}, children }) => {
  const { activeNavId, title, subtitle, subtitleIsH1, hideButtons, hideTopRowChildren } = useHeadingNavigationLinks({ links });

  return (
    <GridContainer smallAt={smallAt}>
      <GridRow>
        <GridCol>
          <nav aria-label="Secondary" className={classNames(styles['heading-box'], styles[`small-at--${smallAt}`], classes.headingBox)}>
            <div>
              <div className={classNames(styles['heading-box__top-row'], { [styles['no-margin']]: noMarginTopRow }, classes.topRow)}>
                {links.length > 0 && (
                  <div style={{ flex: 1, marginRight: '1rem' }}>
                    <h1 style={{ fontSize: '1rem', margin: 0 }}>
                      <div className={classNames(styles['title'], classes.title)}>{title ? title : <Skeleton />}</div>
                      {subtitleIsH1 && (
                        <span className={classNames(styles['sub-title'], classes.subTitle)}>{subtitle ? subtitle : <Skeleton />}</span>
                      )}
                    </h1>
                    {!subtitleIsH1 && (
                      <h2 className={classNames(styles['sub-title'], classes.subTitle)}>{subtitle ? subtitle : <Skeleton />}</h2>
                    )}
                  </div>
                )}
                {!hideTopRowChildren && topRowChildren}
                {!hideButtons && <BoxButtons />}
              </div>
              {links.length > 0 && <BoxNavigation links={links} activeNavId={activeNavId} />}
            </div>
            {sideChildren}
          </nav>
          {children}
        </GridCol>
      </GridRow>
    </GridContainer>
  );
};

export { HeadingBox as default, HeadingBox };
